<!--左侧图标-->
<template>
  <div class="sidebar-container">
    <div class="sidebar-main">
      <router-link
        v-for="item in sidebarRouters"
        :key="item.key"
        :to="item.path"
        v-show="!item.hidden"
        :class="{
          'nav-icon-collapsed':!collapsed,
          'nav-item': true,
          'nav-item-selected': isSelected(item),
        }"
      >
        <a-tooltip :title="item.label" placement="right">
          <div class="nav-item-content">
            <Icon class="nav-icon" :icon="item.icon" />
            <span class="nav-text" v-if="collapsed">{{ item.label }}</span>
          </div>
        </a-tooltip>
      </router-link>
    </div>

    <!-- 底部操作区（可选）
    <div class="sidebar-footer">
      <a-tooltip title="返回业务中心" placement="right">
        <div class="footer-item" @click="goHome">
          <Icon icon="ImportOutlined" class="footer-icon" />
          <span class="footer-text">业务中心</span>
        </div>
      </a-tooltip>
    </div> -->
  </div>
</template>

<script lang="ts">
import { computed, createVNode, defineComponent } from 'vue'
import { getRoot } from '/@/root'
import * as icons from '@ant-design/icons-vue'
import { ERouterName } from '/@/types'
import { useMyStore } from '/@/store'

interface NavOption {
  key: number
  label: string
  path: string | { path: string; query?: any }
  icon: string
  span: string
}
const Icon = (props: { icon: string }) => {
  return createVNode((icons as any)[props.icon])
}

export default defineComponent({
  name: 'Sidebar',
  components: { Icon },
  setup () {
    const store = useMyStore()
    const collapsed = computed(() => store.state.collapsed)
    const sidebarRouters = computed(() => store.state.homeRoutes)
    const root = getRoot()
    const navOptions: NavOption[] = [
      { key: 0, label: ERouterName.TSA_NAME, path: '/' + ERouterName.TSA, icon: 'BankOutlined', span: ERouterName.TSA_NAME },
      { key: 1, label: ERouterName.LIVESTREAM_NAME, path: '/' + ERouterName.LIVESTREAM, icon: 'VideoCameraOutlined', span: ERouterName.LIVESTREAM_NAME },
      { key: 2, label: ERouterName.WAYLINE_NAME, path: '/' + ERouterName.WAYLINE, icon: 'NodeIndexOutlined', span: ERouterName.WAYLINE_NAME },
      { key: 3, label: ERouterName.TASK_NAME, path: '/' + ERouterName.TASK, icon: 'CalendarOutlined', span: ERouterName.TASK_NAME },
      { key: 4, label: ERouterName.ALG_NAME, path: '/' + ERouterName.ALG, icon: 'GlobalOutlined', span: ERouterName.ALG_NAME },
      { key: 5, label: ERouterName.ALARM_NAME, path: '/' + ERouterName.ALARM, icon: 'AlertOutlined', span: ERouterName.ALARM_NAME },
      { key: 6, label: ERouterName.REPORT_NAME, path: '/' + ERouterName.REPORT, icon: 'FileTextOutlined', span: ERouterName.REPORT_NAME },
      { key: 7, label: ERouterName.FLIGHT_AREA_NAME, path: '/' + ERouterName.FLIGHT_AREA, icon: 'GroupOutlined', span: ERouterName.FLIGHT_AREA_NAME },
      { key: 8, label: ERouterName.LAYER_NAME, path: '/' + ERouterName.LAYER, icon: 'EnvironmentOutlined', span: ERouterName.LAYER_NAME },
      { key: 9, label: ERouterName.INDIVIDUAL_TASK_NAME, path: '/' + ERouterName.INDIVIDUAL_TASK, icon: 'CarryOutOutlined', span: ERouterName.INDIVIDUAL_TASK_NAME },
      { key: 10, label: ERouterName.DEVICES_NAME, path: '/' + ERouterName.DEVICES, icon: 'AppstoreAddOutlined', span: ERouterName.DEVICES_NAME },
      { key: 11, label: ERouterName.FLIGHT_TRAJECTORY_NAME, path: '/' + ERouterName.FLIGHT_TRAJECTORY, icon: 'SendOutlined', span: ERouterName.FLIGHT_TRAJECTORY_NAME },
      { key: 12, label: ERouterName.FLIGHT_PLAN_NAME, path: '/' + ERouterName.FLIGHT_PLAN, icon: 'SnippetsOutlined', span: ERouterName.FLIGHT_PLAN_NAME },
    ]

    const isSelected = (item: NavOption) => {
      const path = typeof item.path === 'string' ? item.path : item.path.path
      return root.$route.path?.startsWith(path)
    }

    const goHome = () => {
      root.$router.push('/' + ERouterName.MEMBERS)
    }

    return {
      sidebarRouters,
      navOptions,
      collapsed,
      isSelected,
      goHome
    }
  }
})
</script>

<style scoped lang="scss">
.sidebar-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 83px;
  background: linear-gradient(180deg, #001529 0%, #00284d 100%);
  border-right: 1px solid #404040;
  box-shadow: 2px 0 8px rgba(#001529,0.15);
}

.sidebar-main {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #666;
    border-radius: 2px;
  }
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 5px;
  margin: 4px 8px;
  border-radius: 6px;
  color: #ccc;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  .nav-icon-collapsed{
    .nav-icon{
      font-size: 16px;
    }
  }
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    transform: translateY(-1px);

    .nav-icon {
      color: #1890ff;
    }
  }

  &.nav-item-selected {
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
    color: #fff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);

    .nav-icon {
      color: #fff;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 60%;
      background: #fff;
      border-radius: 0 2px 2px 0;
    }
  }
}

.nav-item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.nav-icon {
  font-size: 20px;
  transition: color 0.3s ease;
}

.nav-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  word-break: break-all;
}

.sidebar-footer {
  padding: 16px 0;
  border-top: 1px solid #404040;
}

.footer-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px;
  margin: 0 8px;
  border-radius: 6px;
  color: #ccc;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;

    .footer-icon {
      color: #52c41a;
    }
  }
}

.footer-icon {
  font-size: 20px;
  margin-bottom: 6px;
}

.footer-text {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

// 响应式设计
@media (max-height: 600px) {
  .nav-item {
    padding: 8px 6px;
    margin: 2px 6px;
  }

  .nav-icon {
    font-size: 18px;
  }

  .nav-text {
    font-size: 11px;
  }
}

// 暗色主题适配
[data-theme='dark'] {
  .sidebar-container {
    background: linear-gradient(180deg, #141414 0%, #262626 100%);
  }
}
</style>
